import { render, staticRenderFns } from "./bank.vue?vue&type=template&id=dbe3ec08&scoped=true"
import script from "./bank.vue?vue&type=script&lang=js"
export * from "./bank.vue?vue&type=script&lang=js"
import style0 from "./bank.vue?vue&type=style&index=0&id=dbe3ec08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe3ec08",
  null
  
)

export default component.exports